<template>
  <div id="pright">
     <div id="mHead"><span>Izabrani ID: <strong>{{klIDs}}</strong></span><span>Artikala: <strong>{{this.koms}}</strong></span><span>Ukupno: <strong>{{this.zbirs}}€</strong></span></div>
    <div id="ctc">
      <div>
        <input v-model.number="klID" placeholder="Upišite ID">
        <div id="ctcBtn" @click="pogledaj()">Prikaži</div>
      </div>
    </div>
    <div style="height:50px"></div>
    <table v-if="itemList.list !== undefined">
      <tr class="tItem" v-for="(item, index) in itemList.list.slice().reverse()" :key="item.artikli_id">
        <td style="height:6vw; width:9vw"><div class="indxx">{{index + 1}}</div><router-link :to="'/ponuda/' + item.kategorija_url + '/' + item.artikli_id + '/' + item.podkat_url + '-' +  item.artikli_naziv.toLowerCase().replace(' ', '-')"><img :src="'/images/namjestaj/' + item.artikli_id + '/0.jpg'" :alt="item.artikli_naziv" style="height:100%;position:relative"></router-link></td>
        <td style="height:6vw; width:20vw; text-align: left; padding: 0px 10px; font-weight:500"><router-link :to="'/ponuda/' + item.kategorija_url + '/' + item.artikli_id + '/' + item.artikli_naziv.toLowerCase().replace(' ', '-')">{{item.podkat_naziv}} {{item.artikli_naziv}}<br><span style="font-size:0.9vw; font-weight: 300" v-if="item.artikli_boje">{{item.artikli_boje}}</span></router-link></td>
        <td style="height:6vw; width:6vw">{{item.artikli_donjacijena.toString().split('').reverse().join('').match(/.{1,3}/g).join('.').split('').reverse().join('')}}€<div class="aDiv" v-if="item.artikli_akcija==1">AKCIJA</div></td>
        <td style="height:6vw; width:2vw">{{item.artikli_kolicina}}</td>
        <td style="height:6vw; width:6vw">{{(item.artikli_kolicina * item.artikli_donjacijena).toString().split('').reverse().join('').match(/.{1,3}/g).join('.').split('').reverse().join('')}}€</td>
      </tr>
    </table>

    <div id="spacer">&nbsp;</div>
    <iframe id="ifro" :src="locs"></iframe>
  </div>
</template>

<script>

import { db } from '../firebase/db'
const mList = db.collection('korpe')

export default {
  name: 'AdminView',
  components: {
  },
  data () {
    return {
      itemList: {},
      locs: '',
      intr: '',
      klID: '',
      koms: 0,
      zbirs: 0
    }
  },
  props: {
    dob: String
  },
  created () {
    if (this.klIDs !== '') {
      this.klID = this.klIDs
    }
  },
  mounted: function () {
    this.pogledaj()
  },
  methods: {
    pogledaj () {
      const k = this.klID + ''
      const ml = mList.doc(k)

      db.collection('opcije').doc('aktivan').update({ broj: k })
      this.$bind('itemList', ml)
      this.$store.dispatch('setKlid', this.klID)
    }
  },
  computed: {
    klIDs () {
      return this.$store.getters.klID
    }
  },
  watch: {
    itemList () {
      this.koms = this.itemList.list.reduce((a, b) => a + (b.artikli_kolicina || 0), 0)
      this.zbirs = this.itemList.list.reduce(function (a, b) {
        return a + Number(b.artikli_donjacijena) * Number(b.artikli_kolicina)
      }, 0).toString().split('').reverse().join('').match(/.{1,3}/g).join('.').split('').reverse().join('')
      this.locs = this.itemList.oitem
    }
  }
}
</script>
<style lang="scss" scoped>

#ifro{
  width: 52vw;
    position: absolute;
    left: 46vw;
    top: 5vw;
    height: 32vw;
}

table{
  position:relative;
  width:68%;
  padding: 0vw 0vw 4vw
}

tr:nth-child(odd){
  background-color: #f2f2f2;
}

td{
  position: relative;
}

.tItem{
  height: 2vw;
  background-color: #fff;
  position: relative;
  border-radius: 0.8vw;
  overflow: hidden;
  transition: all 0.5s;
  img{
    position: absolute;
    height: 100%;
    left: 0%;
    top: 0%;
  }
  /*
  img:hover{
    height: 104%;
    width: 105%;
    left: -2%;
    top: -2.5%;
  }
  */
}

.indxx{
  position: absolute;
  left: -1.9vw;
  top: 2vw;
  background-color: #2e7274;
  border-radius: 8vw;
  width: 1.7vw;
  height: 1.7vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  color: #fff;
}

#ctc{
  position: absolute;
  right: 2vw;
  top: 3vw;
}

#ctc input{
  padding: 3px 5px;
}

#ctcBtn{
  display: inline;
  padding: 10px;
  margin-left: 10px;
  cursor: pointer;
  color: #0e5254;
}

#ctcBtn:hover{
  background-color: #fff;
  border-radius: 10px;
}

#mHead{
  width: 100%;
  text-align: left;
  top: 1vw;
  position: relative;
}

#mHead span{
  margin: 0px 20px
}

#pright{
  display: flex;
  flex-wrap: wrap;
  top: -5.5vw;
  width: 65.5vw;
  right: 0px;
  max-height: 99vh;
  padding-left: 2vw;
  padding-top: 2vw;
}

@media only screen and (max-width: 600px) {
  #pright{
    width: 100vw;
    padding: 60px 0px 0px;
    overflow: hidden;
    overflow-y: auto;
  }
}

.item{
  width: 21vw;
  height: 13vw;
  background-color: #fff;
  position: relative;
  margin: 0.4vw 0.40vw;
  border-radius: 0.8vw;
  overflow: hidden;
  img{
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0%;
    top: 0%;
    transition: height 0.2s, width 0.2s, left 0.2s, top 0.2s;
  }
  /*
  img:hover{
    height: 104%;
    width: 105%;
    left: -2%;
    top: -2.5%;
  }
  */
}

@media only screen and (max-width: 600px) {
  .item{
    width: 90vw;
    height: calc(90vw * 0.61);
    margin: 14px auto;
    border-radius: 12px;
  }
}

.list-enter-active, .list-leave-active {
  transition: all 0.5s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(10px);
  transition: 0s;
}

.gad{
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  padding-bottom: 5vw;
  align-content: baseline;
  width: 100%;
}

#spacer{
  display: none;
}
@media only screen and (max-width: 600px) {
  .gad{
    display: block;
    text-align: center;
    width: 100vw;
    position: relative;
  }
  #spacer{
    display: block;
    height: 18vh;
    width: 300px;
  }
}

.cijena{
  position: absolute;
  z-index: 888;
  color: #000;
  background-color: #FD0;
  width: 6vw;
  height: 2.4vw;
  border-radius: 1.6vw 0px 0px 0px;
  bottom: -0.25vw;
  right: -0.1vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  font-size: 1vw;
  box-shadow: 0px 0px 0.6vw 0px RGBA(0, 0, 0, 0.3);
  transition: width 0.3s;
}

.cijena:hover{
  width: 6vw;
}

#dodaj{
  opacity: 1;
  position: absolute;
  background-color: #fff;
  border-radius: 30px;
  width: 1.2vw;
  height: 0.8vw;
  bottom: 1.3vw;
  left: -1.5vw;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0.05vw 0.05vw 0.2vw 0px RGBA(0,0,0,0.3);
  font-weight: 400;
  transition: opacity 0.3s;
  color: #c00;
  font-size: 0.8vw;
}

.remBtn{
  width: 1.2vw;
  height: 0.8vw;
  bottom: 0.4vw;
  left: -1.5vw;
  position: absolute;
  z-index: 99999;
  border-radius: 1.2vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0.05vw 0.05vw 0.2vw 0px RGBA(0,0,0,0.3);
  opacity: 1;
  font-weight: 400;
  transition: opacity 0.3s;
  color: #db0;
  font-size: 1vw;
}

.remBtn:hover{
  opacity: 1;
}

.aDiv{
  position: absolute;
  z-index: 888;
  color: #F00;
  width: 5vw;
  height: 2.3vw;
  top: 0.4vw;
  right: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  font-size: 1vw;
  background-color: RGBA(0, 0, 0, 0.0);
  border-radius: 0px 0px 0px 1.6vw;
}

@media only screen and (max-width: 600px) {
  .cijena{
    position: absolute;
    z-index: 888;
    color: #000;
    background-color: #FD0;
    width: 60px;
    height: 30px;
    border-radius: 14px 0px 0px 0px;
    bottom: -0.25vw;
    right: -0.1vw;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 900;
    font-size: 18px;
    box-shadow: 0px 0px 0.6vw 0px RGBA(0, 0, 0, 0.3);
  }
}

.naziv{
  position: absolute;
  bottom: 0.4vw;
  left: 0.5vw;
  font-weight: 400;
  color: #fff;
  text-shadow: 0.1vw 0.1vw 0.2vw RGBA(0, 0, 0, 0.6);
}

</style>
